import React, { ReactNode, useContext } from 'react';
import { Link, UNSAFE_RouteContext } from 'react-router-dom';

interface Props {
  href: string;
  className?: string;
  children: ReactNode;
  toRailsPage?: boolean;
}
export default function FlexLink({ className, href, children, toRailsPage }: Props) {
  // use this just to check if link is within the react router
  const reactRouter = useContext(UNSAFE_RouteContext);
  return (reactRouter?.outlet || reactRouter?.matches.length > 0) && !toRailsPage ? (
    <Link to={href} className={className}>
      {children}
    </Link>
  ) : (
    <a href={href} className={className}>
      {children}
    </a>
  );
}
